import { GglSpinner } from '../spinner';
import PageSkeleton from '../skeleton/skeleton_page_loader';

/** Контракт loading-компонента для lazy-загрузки модулей (поля `error`/`retry`/`pastDelay`). */
interface LoadingProps {
  error?: Error;
  retry?(): void;
  pastDelay?: boolean;
}

interface LoadingIndicatorProps extends LoadingProps {
  /** Минимальная высота блока спиннера (проксируется в `GglSpinner` как `outerHeight`). */
  outerHeight?: string;
  /** Legacy-ширина спиннера в px. По умолчанию `'65'`. */
  width?: string | number;
}

/**
 * Fallback для lazy-загрузки модулей: на ошибке показывает сообщение с кнопкой
 * «повторить», при задержке — спиннер. Поведение сохранено 1:1.
 */
export function LoadingIndicator(props: LoadingIndicatorProps) {
  if (props.error) {
    // eslint-disable-next-line no-console
    console.error(props.error);

    return (
      <div className='text-center text-danger'>Ошибка при загрузке модуля: { props.error.message }
        <br /><br /><br />
        <button type='button' className='btn btn-xs btn-default' onClick={ props.retry }>повторить</button>
      </div>
    );
  }

  if (props.pastDelay) {
    const { outerHeight = '320px', width = '65' } = props;
    return <GglSpinner centerBlock outerHeight={ outerHeight } width={ width } />;
  }

  return null;
}

/**
 * Fallback для lazy-загрузки модулей со скелетоном вместо спиннера.
 * Поведение сохранено 1:1.
 */
export function LoadingIndicatorSkeleton(props: LoadingProps) {
  if (props.error) {
    // eslint-disable-next-line no-console
    console.error(props.error);

    return (
      <div className='text-center text-danger'>Ошибка при загрузке модуля: { props.error.message }
        <br /><br /><br />
        <button type='button' className='btn btn-xs btn-default' onClick={ props.retry }>повторить</button>
      </div>
    );
  }

  if (props.pastDelay) {
    return <PageSkeleton />;
  }

  return null;
}
